import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

const LOGO = "/tresses_logo_full.png";

export default function Footer() {
    const { settings } = useSettings();
    return (
        <footer className="relative z-10 bg-[#FBF6F0] border-t border-[#C29A5B]/10 mt-32" data-testid="footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid md:grid-cols-4 gap-12">
                <div>
                    <div className="mb-6">
                        <img src={LOGO} alt="The Tresses — Unisex Salon" className="h-36 w-auto object-contain" data-testid="footer-logo" />
                    </div>
                    <p className="text-sm text-[#7A5262] leading-relaxed">
                        A unisex sanctuary where craft meets care. Editorial cuts, premium colour, and bespoke skin rituals — all under one luxurious roof.
                    </p>
                </div>

                <div>
                    <h4 className="text-overline mb-4">Visit</h4>
                    <ul className="space-y-3 text-sm text-[#7A5262]">
                        <li className="flex gap-2"><MapPin size={14} className="text-[#8F622C] mt-1 flex-shrink-0" /> {settings.contact_address || "12, Linking Road, Bandra W, Mumbai 400050"}</li>
                        <li className="flex gap-2"><Phone size={14} className="text-[#8F622C] mt-1 flex-shrink-0" /> {settings.contact_phone || "+91 98765 43210"}</li>
                        <li className="flex gap-2"><Mail size={14} className="text-[#8F622C] mt-1 flex-shrink-0" /> {settings.contact_email || "hello@thetresses.in"}</li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-overline mb-4">Hours</h4>
                    <ul className="space-y-2 text-sm text-[#7A5262]">
                        <li>{settings.hours_weekday || "Mon — Fri · 10:00 — 21:00"}</li>
                        <li>{settings.hours_weekend || "Sat — Sun · 09:00 — 22:00"}</li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-overline mb-4">Follow</h4>
                    <div className="flex gap-3">
                        <a href={settings.instagram_url || "#"} target="_blank" rel="noreferrer" className="border border-[#6B1535]/15 p-3 hover:border-[#C29A5B] transition-colors" data-testid="footer-instagram"><Instagram size={16} className="text-[#8F622C]" /></a>
                        <a href={settings.facebook_url || "#"} target="_blank" rel="noreferrer" className="border border-[#6B1535]/15 p-3 hover:border-[#C29A5B] transition-colors" data-testid="footer-facebook"><Facebook size={16} className="text-[#8F622C]" /></a>
                    </div>
                </div>
            </div>
            <div className="gold-divider opacity-40" />
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
                <p className="text-xs text-[#8A6574]">© {new Date().getFullYear()} Tresses Unisex Salon. Crafted with intention.</p>
                <p className="text-xs tracking-[0.3em] text-[#8A6574] uppercase">{settings.tagline || "Elegance for Everyone"}</p>
            </div>
        </footer>
    );
}
